/**
 * Marquesina con animación o texto estático según configuración
 */

import React from 'react';
import { Box, Typography } from '@mui/material';
import CampaignIcon from '@mui/icons-material/Campaign';

const Marquesina = ({ text, isFixed }) => {
    if (!text || text.trim() === '') {
        return null;
    }

    return (
        <Box
            sx={{
                background: '#cc071e',
                borderRadius: 2,
                overflow: 'hidden',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                border: '2px solid #a30618'
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    px: 3,
                    py: 2,
                    backgroundColor: 'rgba(255,255,255,0.1)'
                }}
            >
                {/* Icono de megáfono */}
                <CampaignIcon
                    sx={{
                        fontSize: 36,
                        color: 'white'
                    }}
                />

                {/* Contenedor de texto */}
                <Box
                    sx={{
                        flex: 1,
                        overflow: 'hidden',
                        position: 'relative',
                        height: 40
                    }}
                >
                    <Typography
                        sx={{
                            color: 'white',
                            fontSize: '1.5rem',
                            fontWeight: 600,
                            lineHeight: '40px',
                            whiteSpace: 'nowrap',
                            // Texto fijo centrado
                            ...(isFixed && {
                                textAlign: 'center',
                                width: '100%'
                            }),
                            // Texto animado
                            ...(!isFixed && {
                                display: 'inline-block',
                                paddingLeft: '100%',
                                animation: 'marquee 20s linear infinite',
                                '@keyframes marquee': {
                                    from: {
                                        transform: 'translateX(0)'
                                    },
                                    to: {
                                        transform: 'translateX(-100%)'
                                    }
                                }
                            })
                        }}
                    >
                        {text}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default Marquesina;
